import moment from "moment";
import phonenumber from "google-libphonenumber";

export function getNameByEmail(email) {
  if (!email) return;
  let arr = email.split("@");
  return arr[0];
}

export function dateComparator(date1, date2) {
  var m1 = moment(date1, "MM/DD/YYYY HH:mm A");
  var m2 = moment(date2, "MM/DD/YYYY HH:mm A");
  if (!m1.isValid() && !m2.isValid()) {
    return 0;
  }
  if (!m1.isValid()) {
    return -1;
  }
  if (!m2.isValid()) {
    return 1;
  }
  return m1.valueOf() - m2.valueOf();
}

export function dateformat(dataStr, pattern = "YYYY-MM-DD HH:mm:ss", show) {
  if (!dataStr && show) return "Now";
  if (!dataStr && !show) return "";
  return moment
    .unix(dataStr)
    .tz("America/Los_Angeles")
    .format(pattern);
}
export function date2timestamp(value, ism) {
  if (ism) {
    return moment(value).valueOf() / 1000;
  } else {
    return moment(value).valueOf();
  }
}

export function queryArray(arr, q, key) {
  return arr.filter((v) =>
    Object.entries(v).some((v) => {
      if (key) {
        if (key == v[0]) {
          return new RegExp(q + "").test(v[1]);
        }
      } else {
        return new RegExp(q + "").test(v[1]);
      }
    })
  );
}

export function sortArray(arr, key, order) {
  order = order == "asc" ? "asc" : "desc";
  return arr.sort(__compare(key, order));
}
function __compare(property, order) {
  return function(obj1, obj2) {
    var value1 = obj1[property];
    var value2 = obj2[property];
    if (order == "asc") return value1 - value2;
    if (order == "desc") return value2 - value1;
  };
}

export function roundNum(value, n) {
  return Math.round(value * Math.pow(10, n)) / Math.pow(10, n);
}

export function workHours(value, type) {
  /** value second **/
  type = type ? type : "remote";
  let min = value / 60;
  let hour = parseInt(min / 60);
  let fract = min - hour * 60;
  let val = 0;
  let sval = 0;
  if (value == 0) return val;
  if (type == "remote") {
    if (hour == 0) {
      val = 1;
    } else {
      val = hour;
      if (fract >= 5 && fract < 35) sval = 0.5;
      if (fract >= 35) sval = 1;
      val += sval;
    }
  }
  if (type == "onsite") {
    if (hour < 2) {
      val = 2;
    } else {
      val = hour;
      if (fract >= 5 && fract < 35) sval = 0.5;
      if (fract >= 35) sval = 1;
      val += sval;
    }
  }
  if (type == "timesheet") {
    val = hour + fract / 60;
    if (!Number.isInteger(val)) {
      val = Number(val.toFixed(2));
    }
  }
  return val;
}

export function parsePhoneNumber(input) {
  try {
    const PNF = phonenumber.PhoneNumberFormat;
    const phoneUtil = phonenumber.PhoneNumberUtil.getInstance();
    const number = phoneUtil.parseAndKeepRawInput(input, "US");
    return phoneUtil.format(number, PNF.E164);
  } catch (error) {
    return null;
  }
}

export function randomString(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function deleteConfirm(callback) {
  if (confirm("Do you want to delete?")) {
    callback();
  }
}

export function toNumber(a) {
  const f = parseFloat(a);
  if (isNaN(f)) {
    return 0;
  } else {
    return f;
  }
}

export function getFullName(firstName, lastName) {
  let fullName = "";
  if (firstName && lastName) fullName = firstName + " " + lastName;
  else if (firstName) fullName = firstName;
  else if (lastName) fullName = lastName;
  return fullName;
}

export function isObjEmpty(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export function validateEmail(email) {
  var re = /[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/;
  return re.test(String(email).toLowerCase());
}

export function currencyFilter(value, symbol = "$", fixed) {
  let zero = 0;
  let result = parseFloat(value);
  fixed = fixed ? fixed : 0;
  if (!isNaN(result) && typeof result == "number") {
    result = result.toFixed(fixed);
    return symbol ? symbol + result : result;
  } else {
    return symbol ? symbol + zero.toFixed(fixed) : zero.toFixed(fixed);
  }
}

export function fixHours(hours) {
  if (hours) {
    if (Number.isInteger(hours)) {
      return hours;
    } else {
      return hours.toFixed(2);
    }
  } else {
    return 0;
  }
}

export function validURL(str) {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
    "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
    "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(str);
}

export function toDbData(data) {
  if (!data || typeof data !== "object") return data;
  for (let key in data) {
    if (typeof data[key] === "undefined") {
      data[key] = null;
    }
  }
  return data;
}
